import React from "react";
import CheckedIcon from "../../icons/dashboard/CheckedIcon";

interface StepperProps {
  currentStep: number;
  completedSteps: any;
  className: string;
  handleOnClick?: any;
}
const CustomStepper2Step = ({
  completedSteps,
  currentStep,
  className,
  handleOnClick,
}: StepperProps) => {
  return (
    <div className="w-[40px] flex flex-col items-center">
      <div
        className="flex flex-col"
        style={{ height: currentStep === 1 ? "-webkit-fill-available" : "" }}
      >
        <div
          className={`${
            currentStep === 1
              ? "bg-btnPrimaryActive text-white"
              : "bg-white text-txtPrimary cursor-pointer"
          } rounded-full border-[1px] !w-[38px] !h-[39px] `}
          onClick={() => {
            if (completedSteps.includes(1)) {
              handleOnClick(1);
            }
          }}
        >
          <div className="w-full h-full flex justify-center items-center">
            {completedSteps.includes(1) ? <CheckedIcon /> : <p>1</p>}
          </div>
        </div>
        {/* Connector between the two circles. Sized explicitly rather than via
            the `.answerSection` accordion classes: that rule caps max-height
            at 0, which collapsed the line entirely. While step 1 is active it
            fills the column (solid on top, dotted below, as in the design);
            once step 1 is done it shrinks to the short grey link. */}
        <div
          className={`${
            currentStep === 1 ? "flex-1 min-h-0" : className
          } overflow-hidden flex flex-col gap-[6px] items-center`}
        >
          <div
            className={`${
              currentStep === 1
                ? "h-[50%] bg-btnPrimaryActive"
                : "h-[100%] bg-btnOutlineStroke"
            } w-[1px] shrink-0`}
          ></div>
          {currentStep === 1 && (
            // Dotted lower half: a stretching segment painted with a repeating
            // gradient, so it always runs right up to the second circle instead
            // of a fixed number of dashes that leaves a gap at each end.
            <div className="w-[1px] flex-1 min-h-0 bg-[repeating-linear-gradient(to_bottom,var(--color-btn-primary-active)_0_5px,transparent_5px_11px)]"></div>
          )}
        </div>
      </div>

      {/* <div className="h-[1px] bg-white w-full" /> */}
      <div>
        <div
          className={`${
            currentStep === 2
              ? "bg-btnPrimaryActive text-white"
              : "bg-white text-txtPrimary cursor-pointer"
          } rounded-full border-[1px] !w-[38px] !h-[38px]`}
          onClick={() => {
            if (completedSteps.includes(2)) {
              handleOnClick(2);
            }
          }}
        >
          <div className="w-full h-full flex justify-center items-center">
            {completedSteps.includes(2) ? <CheckedIcon /> : <p>2</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomStepper2Step;
